<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'ADD_BROCHURES' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
    <!-- Own search field: lib-filter-list routes its search through the URL, which filters the cart behind this modal -->
    <div class="row mb-3">
      <div class="col-12 col-md-6">
        <input
          type="text"
          class="form-control"
          [placeholder]="'SEARCH' | translate"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchTermChange($event)"
        />
      </div>
    </div>
    <!-- <lib-product-list-by-ids *ngIf="productIds" [productIds]="productIds"></lib-product-list-by-ids> -->
    <lib-filter-list #productList [configService]="configService"></lib-filter-list>
</div>

<div class="modal-footer">
  <button  class="btn btn-sm btn-primary btn-default px-4" (click)="activeModal.close(false)" translate>
    NOT_ADD_BROCHURES
  </button>
  <button class="btn btn-sm btn-outline-primary px-4" (click)="activeModal.close(true)" translate>
    CLOSE
  </button>
</div>